import React, { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Gallery({ images }) {
  const [openIdx, setOpenIdx] = useState(null);
  const isOpen = openIdx !== null;
  const [cat, setCat] = useState("Vše");
  const cats = ["Vše", ...Array.from(new Set(images.map((i) => i.cat)))];
  const filtered = cat === "Vše" ? images : images.filter((i) => i.cat === cat);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpenIdx(null);
      if (e.key === "ArrowRight") setOpenIdx((i) => (i + 1) % filtered.length);
      if (e.key === "ArrowLeft") setOpenIdx((i) => (i - 1 + filtered.length) % filtered.length);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen, filtered.length]);

  return (
    <div data-testid="gallery">
      <div className="flex flex-wrap gap-2 mb-8">
        {cats.map((c) => (
          <button key={c} onClick={() => setCat(c)} className={`text-xs tracking-[.18em] uppercase px-3.5 py-2 border transition-colors ${cat === c ? "bg-burgundy text-ivory border-burgundy" : "border-charcoal/20 text-charcoal/70 hover:border-burgundy hover:text-burgundy"}`}>
            {c}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 [grid-auto-rows:180px] md:[grid-auto-rows:220px]">
        {filtered.map((img, i) => {
          const patterns = ["col-span-2 row-span-2", "col-span-1", "col-span-1 row-span-2", "col-span-1", "col-span-2", "col-span-1", "col-span-1", "col-span-2", "col-span-1"];
          const cls = patterns[i % patterns.length];
          return (
            <button key={i} type="button" onClick={() => setOpenIdx(i)} className={`relative overflow-hidden group ${cls}`} data-testid={`gallery-item-${i}`}>
              <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.05]" />
              <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/25 transition-colors" />
            </button>
          );
        })}
      </div>

      {isOpen && (
        <div className="fixed inset-0 z-50 bg-charcoal/95 flex items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="lightbox">
          <button onClick={() => setOpenIdx(null)} className="absolute top-5 right-5 text-ivory p-2" aria-label="Zavřít"><X size={28} /></button>
          <button onClick={() => setOpenIdx((i) => (i - 1 + filtered.length) % filtered.length)} className="absolute left-4 md:left-8 text-ivory p-3" aria-label="Předchozí"><ChevronLeft size={32} /></button>
          <button onClick={() => setOpenIdx((i) => (i + 1) % filtered.length)} className="absolute right-4 md:right-8 text-ivory p-3" aria-label="Další"><ChevronRight size={32} /></button>
          <img src={filtered[openIdx].src} alt={filtered[openIdx].alt} className="max-h-[85vh] max-w-full object-contain" />
          <div className="absolute bottom-6 left-0 right-0 text-center text-ivory/80 text-sm">{filtered[openIdx].alt}</div>
        </div>
      )}
    </div>
  );
}
